import { render, staticRenderFns } from "./docList.vue?vue&type=template&id=2b6bdc68&scoped=true"
import script from "./docList.vue?vue&type=script&lang=js"
export * from "./docList.vue?vue&type=script&lang=js"
import style0 from "./docList.vue?vue&type=style&index=0&id=2b6bdc68&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6bdc68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3430498393/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6bdc68')) {
      api.createRecord('2b6bdc68', component.options)
    } else {
      api.reload('2b6bdc68', component.options)
    }
    module.hot.accept("./docList.vue?vue&type=template&id=2b6bdc68&scoped=true", function () {
      api.rerender('2b6bdc68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/docList.vue"
export default component.exports